import style from './../Report.module.scss';
import TreatmentsByTimeGraph from '../TreatmentsReport/TreatmentsByTimeGraph/TreatmentsByTimeGraph';
import TreatmentsByStaff from '../TreatmentsReport/TreatmentsByStaff/TreatmentsByStaff';
import TreatmentsByArea from '../TreatmentsReport/TreatmentsByArea/TreatmentsByArea';
import TreatmentsBySkin from '../TreatmentsReport/TreatmentsBySkin/TreatmentsBySkin';
import ErrorsByTimeGraph from '../ErrorsReport/ErrorsByTimeGraph/ErrorsByTimeGraph';
import ErrorsByType from '../ErrorsReport/ErrorsByType/ErrorsByType';
import ErrorsByPlatform from '../ErrorsReport/ErrorsByPlatform/ErrorsByPlatform';
import StaffReport from '../StaffReport/StaffReport';
import ReportTypeStructure from '../ReportTypeStructure';
import moment from 'moment';

const ClinicReport = ({report, isChain, isStandalone}) => {
    const {data} = report;
    const {clinic, stats, treatments, errors, staff} = data;
    const orgType = isChain ? 'Chain' : 'Clinic';

    const getHeader = () => {
        return (
            <div className='d-flex'>
                {clinic && clinic.logo && <img src={clinic.logo} alt='logo' className={style.clinicLogo} />}
                <div>
                    <h1>{clinic && clinic.name ? clinic.name : 'Unknown clinic'}: {orgType} Report</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <h5>{orgType} Statistics</h5>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{stats && stats.total_patients ? stats.total_patients : '?'}</h3>
                            <label>Total Patients</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{stats && stats.total_platforms ? stats.total_platforms : '?'}</h3>
                            <label>Total Platforms</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{stats && stats.total_applicators ? stats.total_applicators : '?'}</h3>
                            <label>Total Applicators</label>
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Treatments Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments?.stats?.total}</h3>
                            <label>Total Treatments</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments?.stats?.weekly_average}</h3>
                            <label>Avg. Weekly Treatments</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments?.stats?.most_popular_area}</h3>
                            <label>Most Popular Area</label>
                        </div>
                    </div>

                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <TreatmentsByTimeGraph data={treatments.by_time.data} tick={treatments.by_time.tick} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')}>
                            <TreatmentsByArea data={treatments.by_area} />
                        </div>
                    </div>

                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')}>
                            <TreatmentsByStaff data={treatments.by_staff}  />
                        </div>
                        <div className={[style.card, style.col6].join(' ')}>
                            <TreatmentsBySkin data={treatments.by_skin_type} />
                        </div>
                    </div>
                </section>
                {staff && <StaffReport report={report} onlyContent={true} />}
                <section>
                    <h5>Errors Overview</h5>

                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByType data={errors.by_type} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByPlatform data={errors.by_platform} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')}>
                            <ErrorsByTimeGraph data={errors.by_time.data} tick={errors.by_time.tick} />
                        </div>
                    </div>

                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={getHeader()} content={getContent()} />
    )
}

export default ClinicReport;